import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TicketFilter } from '@shared/entities/ticketFilter';
import { ApiService } from '@shared/services';
import { BehaviorSubject, Observable, Subject, shareReplay, switchMap, take, tap } from 'rxjs';
import { TicketFilterURL } from './ticket.service';

const LOG_PREFIX = '[Api][TicketFilters] ';

@Injectable({
  providedIn: 'root'
})
export class TicketFiltersService extends ApiService<TicketFilter> {
  private refresh$: Subject<boolean>;
  all$: Observable<TicketFilter>;
  currentFilters: TicketFilterURL = {};

  set filters(value: TicketFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/tickets/filters';
    const detailUrl = '/tickets/filters';

    super(TicketFilter, masterUrl, detailUrl);

    this.refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this.refresh$.pipe(
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        this.setUrlParameter('status', 'CLOSED');
        if (this.currentFilters.caseNumber) {
          this.setUrlParameter('caseNumber', this.currentFilters.caseNumber);
        }
        if (this.currentFilters.serialNumber) {
          this.setUrlParameter('serialNumber', this.currentFilters.serialNumber);
        }
        this.setUrlParameter('order_by', this.currentFilters.orderBy || 'createdDate');
        if (this.currentFilters.orderBy) {
          // this.setUrlParameter('order_by', this.currentFilters.orderBy);
          this.setUrlParameter('direction', 'ASC');
        }
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this.refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
